var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 27,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 0 27)",
    fill: "#EDF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8585 13.5318L11.5183 8.19171C11.3948 8.0681 11.2299 8 11.0541 8C10.8783 8 10.7135 8.0681 10.5899 8.19171L10.1967 8.58487C9.94078 8.84107 9.94078 9.25745 10.1967 9.51326L14.6809 13.9975L10.1917 18.4867C10.0682 18.6104 10 18.7751 10 18.9508C10 19.1267 10.0682 19.2915 10.1917 19.4152L10.585 19.8083C10.7086 19.9319 10.8734 20 11.0492 20C11.225 20 11.3898 19.9319 11.5134 19.8083L16.8585 14.4634C16.9823 14.3394 17.0503 14.1738 17.0499 13.9978C17.0503 13.8211 16.9823 13.6557 16.8585 13.5318Z",
    fill: "#ADB7BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBg);
export default __webpack_public_path__ + "static/media/next_bg.d106aa267b9815794831042c1d103e1f.svg";
export { ForwardRef as ReactComponent };